import { type Stripe, loadStripe } from "@stripe/stripe-js";



import { config } from "./Config";


export class JavascriptLoader {
    public static stripeInstance: Stripe;
    private static initPromise: Promise<Stripe> | undefined;

    public static load(url: string, identifier: string): Promise<void> {
        return new Promise((resolve, reject) => {
            const scriptLoad = document.createElement("script");
            scriptLoad.src = url;
            scriptLoad.className = identifier;

            scriptLoad.addEventListener(
                "load",
                () => {
                    resolve();
                },
                { once: true }
            );

            scriptLoad.addEventListener(
                "error",
                () => {
                    reject(new Error("Failed to load script"));
                },
                { once: true }
            );

            const old = document.head.getElementsByClassName(identifier);
            if (old.length > 0) old[0].remove();

            document.head.appendChild(scriptLoad);
        });
    }

    public static requireStripe(): Promise<Stripe> {
        if (JavascriptLoader.initPromise !== undefined) return JavascriptLoader.initPromise;

        const prom = new Promise<Stripe>((resolve, reject) => {
            if (JavascriptLoader.stripeInstance !== undefined) {
                resolve(JavascriptLoader.stripeInstance);
                return;
            }

            const scriptLoad = document.createElement("script");
            scriptLoad.src = "https://js.stripe.com/v3/";

            scriptLoad.addEventListener(
                "load",
                async () => {
                    const stripeInstance = await loadStripe(config.stripePublicKey);
                    if (stripeInstance == null) {
                        throw new Error("Stripe instance is missing.");
                    }
                    JavascriptLoader.stripeInstance = stripeInstance;
                    resolve(JavascriptLoader.stripeInstance);
                    JavascriptLoader.initPromise = undefined;
                },
                { once: true }
            );

            scriptLoad.addEventListener(
                "error",
                () => {
                    reject(new Error("Failed to load stripe script"));
                },
                { once: true }
            );

            document.head.appendChild(scriptLoad);
        });

        if (JavascriptLoader.stripeInstance === undefined) JavascriptLoader.initPromise = prom;

        return prom;
    }
}
